import React from "react";

import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
export const Blog = () => {
  return (
    <>
     
        <hr />
        
<div class="ud-container ud-mx-auto ud-py-8">
        {/* <!-- How to Use Rundoit --> */}
        <div class="ud-p-6 ud-my-4 ud-bg-white ud-rounded-lg ud-shadow-md ud-mb-8">
        <h2 class="ud-text-2xl ud-font-bold mb-4">How to Use it:</h2>
        <ol class="ud-list-decimal list-inside text-gray-700">
            <li>Add Tasks: Create a short list yourself or begin with a starter template.</li>
            <li>Choose a Mode: Use Random when you cannot decide, Start for a 25-minute session, or Flow for an open-ended timer.</li>
            <li>Finish Clearly: Mark the task complete, restore it if needed, or move older completed work to the archive.</li>
        </ol>
    </div>

    {/* <!-- Conclusion --> */}
    <div class="ud-p-6 bg-white ud-rounded-lg ud-shadow-md ud-mb-8">
        <p class="ud-text-gray-700 ud-font-bold">Rundoit is designed to reduce the friction between seeing your list and beginning one clear next action.</p>
    </div>

    {/* <!-- Random Mode --> */}
    <div class="ud-p-6 ud-bg-white ud-rounded-lg ud-shadow-md mb-8">
        <h2 class="ud-text-2xl ud-font-bold ud-mb-4">Random Mode:</h2>
        <p class="ud-text-gray-700">Random Mode picks one task from your active list. Roll again if the choice does not fit, or mark it complete when the work is done.</p>
    </div>

    {/* <!-- Flow Mode --> */}
    <div class="ud-p-6 ud-bg-white ud-rounded-lg ud-shadow-md mb-8">
        <h2 class="ud-text-2xl ud-font-bold ud-mb-4">Flow Mode:</h2>
        <p class="ud-text-gray-700">Flow Mode highlights one task and starts an open-ended timer. Pause for a break and resume when you are ready.</p>
    </div>

    {/* <!-- Start Here Mode --> */}
    <div class="ud-p-6 ud-bg-white ud-rounded-lg ud-shadow-md mb-8">
        <h2 class="ud-text-2xl ud-font-bold ud-mb-4">Start Mode</h2>
        <p class="ud-text-gray-700">Start Mode takes the first active task, runs a 25-minute focus session, then offers a break before moving to the next task.</p>
    </div>

    {/* <!-- Refresh Feature --> */}
    <div class="ud-p-6 ud-bg-white ud-rounded-lg ud-shadow-md mb-8">
        <h2 class="ud-text-2xl ud-font-bold ud-mb-4">Refresh:</h2>
        <p class="ud-text-gray-700">Refresh clears the current selection and resets the active timer mode without deleting your task list.</p>
    </div>

</div>

        <section>
        <div className="call-to-action">
          <div>
            Sign up for a free account to save up to five active tasks and use every focus mode.
            <br></br>
          </div>

          <div>
            <Button variant="contained" color="primary" size="large">
              {" "}
              <Link
                to="/signup"
                style={{ textDecoration: "none", color: "white" }}
              >
                Sign Up
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};
